module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAA40lEQVRYhe2X3wnCMBCHfxEHcARHcID44AZ2kYiTiFlEN1Cw7zpCR3CDiCWo9LjLn1JFmu+p3LXJd0cuUIweJTXAGb0GsAMwJ8k3K2XrszP66p/v5A2BCZfymx8Cm3+yAHByRs9IRoAV8JWnkiwhCcRW3iVJQhLoQ7TEUAKIlRhSIEpiaIGgxJREMlG2Fu8Ujm90QIS1dkY7EuxHe2N2V/h5B4pA/BTsLyQksllK2Rd/1IHIilIph7BMQZmCUR3CG4kEBBoSyafhflgkgS2J5MOuxQooWx8BVD078fy28msVKAAeLWE4KRjdbgAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_btn_confirmation@2x.png
// module id = 739
// module chunks = 0